import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import type { AppConfig } from '../../config';

import type { Logger } from '@seek/logger';
import { GET_COMPANY_PROFILE_AND_REVIEW_SUMMARY_QUERY } from './graphqlQueries';
import type { CompanyDetails } from './types';

export type CompanyDetailsService = ReturnType<
  typeof createCompanyDetailsService
>;

export const createCompanyDetailsService = ({
  config,
  client,
  logger,
}: {
  client: ApolloClient<NormalizedCacheObject>;
  config: AppConfig;
  logger: Logger;
}) => {
  const getCompanyDetails = async (
    companyId: string,
    isDraft = false,
  ): Promise<CompanyDetails> => {
    const variables = {
      companyDetailsId: companyId,
      draft: isDraft,
      locale: config.locale,
    };
    const response = await client.query<{
      companyDetails: CompanyDetails | null;
    }>({
      query: GET_COMPANY_PROFILE_AND_REVIEW_SUMMARY_QUERY,
      variables,
    });

    if (response?.error || response?.errors) {
      logger.error(
        { error: response.error ?? response.errors, variables },
        'Error calling getCompanyDetails',
      );
    }

    if (!response?.data?.companyDetails?.companyProfile) {
      throw new Error(`Company profile not found for company ID: ${companyId}`);
    }

    return response.data.companyDetails;
  };

  return {
    getCompanyDetails,
  };
};
